import { gql } from "@apollo/client";

export const GET_NPID_CONTRATO = gql`
    query NutricionParenteralRIByDatosGeneralesId (
        $idDatosGenerales: Int!
    ) {
        nutricionParenteralRIByDatosGeneralesId (
            idDatosGenerales: $idDatosGenerales
        ){
            nutricionParenteralRI{
                idNutricionParenteralIntradialiticaRI
                volumenMagistral
            }
            diaConexionMagistral
            diaConexionEstandar
        }
    }
`;


export const adaptNPIDContrato = (data) => {
  return {
    idAlimentacionEnteralRI: data?.nutricionParenteralRIByDatosGeneralesId?.nutricionParenteralRI?.idAlimentacionEnteralRI,
    volumenMagistral: data?.nutricionParenteralRIByDatosGeneralesId?.nutricionParenteralRI?.volumenMagistral,
    diaConexionRIMagistral: data?.nutricionParenteralRIByDatosGeneralesId?.diaConexionMagistral,
    diaConexionRIEstandar: data?.nutricionParenteralRIByDatosGeneralesId?.diaConexionEstandar
  };
};